import React from 'react';

// A hand cursor that sits on the highlighted element and pulses a "tap".
// `at` = { x, y } fractions of the target rect where the hand points (default center-ish).
const AnimatedPointer = ({ rect, at }) => {
  if (!rect) return null;

  const fx = at?.x ?? 0.5;
  const fy = at?.y ?? 0.62;
  const x = rect.x + rect.width * fx;
  const y = rect.y + rect.height * fy;

  return (
    <div className="onb-pointer" style={{ top: y, left: x }}>
      <span className="onb-pointer-ripple" />
      <svg
        className="onb-pointer-hand"
        width="44"
        height="44"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9 11V5.5a1.5 1.5 0 0 1 3 0V11m0-1.5a1.5 1.5 0 0 1 3 0V11m0-.5a1.5 1.5 0 0 1 3 0V15c0 3.3-2.2 6-6 6-2.2 0-3.5-.8-4.6-2.2L6 14.5c-.6-.8-.3-1.7.5-2.1.7-.4 1.6-.2 2.1.5L9 13.5V11Z"
          fill="#fff"
          stroke="#0E0E10"
          strokeWidth="1.2"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};

export default AnimatedPointer;
